module.exports = __webpack_public_path__ + "static/img/6.8bf20fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/6.png
// module id = f5FE
// module chunks = 0